@if (showLdr) {
<ds-loading></ds-loading>
}

<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>

<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="driverSldrVisible"
  nzPlacement="right"
  nzTitle="Driver Profile"
  (nzOnClose)="driverSldrVisible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedDriverForSlider) {
    <app-driver-slider [driver]="selectedDriverForSlider"></app-driver-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Enhanced Modern Header Section - Matching Route Deviation Dashboard -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 shadow-xl border-b-4 border-blue-200 mb-6 overflow-hidden dshbordhdr cstmmrgin"
>
  <!-- Decorative Background Pattern -->
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 rounded-full blur-3xl"
    ></div>
  </div>

  <div class="relative flex items-center justify-between px-8 py-2">
    <div class="flex-1">
      <div class="flex items-center gap-3">
        <!-- Icon Badge -->
        <div
          class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg flex items-center justify-center"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        </div>

        <!-- Title Section -->
        <div>
          @if (clntDtls && clntDtls.length > 0) {
          <h1
            class="text-xl font-bold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent mb-0"
            style="font-size: 20px"
          >
            @if (clntDtls[0].clnt_id==7) {
            <span>
              {{ hdrLbl }} Dashboard @if (userDtls?.clap_in==1) {
              <span class="text-blue-600 font-normal text-sm ml-1">· CLAP</span>
              }
            </span>
            } @if (clntDtls[0].clnt_id!=7) {
            <span>{{ hdrLbl }} Dashboard</span>
            }
          </h1>
          }
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3">
      @if (button_in) {
      <button
        (click)="gotoback()"
        class="group flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white rounded-xl transition-all duration-300 shadow-lg hover:shadow-2xl font-semibold text-sm border-2 border-gray-400/50 hover:border-gray-300 cursor-pointer"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          ></path>
        </svg>
        <span>Go Back</span>
      </button>
      } @if (filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="group flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl transition-all duration-300 shadow-lg hover:shadow-2xl font-semibold text-sm border-2 border-blue-400/50 hover:border-blue-300 cursor-pointer"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          class="text-base group-hover:rotate-90 transition-transform duration-300"
        ></span>
        <span>Hide Filters</span>
      </button>
      } @if (!filterPanelOpen) {
      <button
        (click)="toggleFilterPanel()"
        class="group flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-slate-500 to-slate-600 hover:from-slate-600 hover:to-slate-700 text-white rounded-xl transition-all duration-300 shadow-lg hover:shadow-2xl font-semibold text-sm border-2 border-slate-400/50 hover:border-slate-300 cursor-pointer"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          class="text-base group-hover:rotate-90 transition-transform duration-300"
        ></span>
        <span>Show Filters</span>
      </button>
      }
    </div>
  </div>

  <!-- Bottom Accent Line -->
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500"
  ></div>
</div>

<!-- PDF export bar (Tirupathi only, below the Show Filters strap): animated icon <-> from/to filter + Generate -->
<!-- Super-admin only (spr_admn_in == 1): hidden entirely for other users via canExportPdf. -->
@if (isTirupatiTenant && canExportPdf) {
<div>
  <!-- Floating Action Button (fixed bottom-right). Click handler unchanged:
    togglePdfFilter() opens the date-range popover -> generatePdf(). -->
  @if (!showPdfFilter) {
  <button
    (click)="togglePdfFilter()"
    type="button"
    title="Generate PDF"
    aria-label="Generate PDF"
    class="pdf-fab"
  >
    <svg
      class="pdf-fab__icon"
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 13h8v2H8v-2zm0 4h8v2H8v-2z"
      />
    </svg>
  </button>
  }
  <!-- Redesigned PDF export popover. All model bindings + handlers are
    preserved (pdfFromDate, pdfToDate, dateFormat, disabledDate,
    generatePdf, togglePdfFilter) — this is a pure UI/UX refresh. -->
  @if (showPdfFilter) {
  <div class="pdf-fab-pop" role="dialog" aria-label="Generate report">
    <!-- Header strap: title + close X -->
    <div class="pdf-fab-pop__hdr">
      <div class="pdf-fab-pop__title">
        <span class="pdf-fab-pop__badge" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </span>
        <span class="pdf-fab-pop__ttext">
          <span class="pdf-fab-pop__t1">Generate Report</span>
          <span class="pdf-fab-pop__t2">Pick a date range</span>
        </span>
      </div>
      <button
        (click)="togglePdfFilter()"
        type="button"
        class="pdf-fab-pop__close"
        title="Close"
        aria-label="Close"
      >
        ×
      </button>
    </div>
    <!-- Date-range field row with labelled cards + centred arrow chip -->
    <div class="pdf-fab-pop__range">
      <label class="pdf-fab-pop__field">
        <span class="pdf-fab-pop__flabel">From</span>
        <nz-date-picker
          [(ngModel)]="pdfFromDate"
          nzPlaceHolder="Select date"
          [nzFormat]="dateFormat"
          [nzDisabledDate]="disabledDate"
          [nzAllowClear]="false"
          class="pdf-fab-pop__dp"
          style="width: 100%"
        >
        </nz-date-picker>
      </label>
      <span class="pdf-fab-pop__arrow" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="13 6 19 12 13 18" />
        </svg>
      </span>
      <label class="pdf-fab-pop__field">
        <span class="pdf-fab-pop__flabel">To</span>
        <nz-date-picker
          [(ngModel)]="pdfToDate"
          nzPlaceHolder="Select date"
          [nzFormat]="dateFormat"
          [nzDisabledDate]="disabledDate"
          [nzAllowClear]="false"
          class="pdf-fab-pop__dp"
          style="width: 100%"
        >
        </nz-date-picker>
      </label>
    </div>
    <!-- Primary action -->
    <button (click)="generatePdf()" type="button" class="pdf-fab-pop__cta">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="pdf-fab-pop__cta-ico"
        aria-hidden="true"
      >
        <path d="M12 4v12" />
        <polyline points="6 10 12 4 18 10" />
        <rect x="4" y="18" width="16" height="3" rx="1" />
      </svg>
      <span>Generate PDF</span>
    </button>
  </div>
  }
</div>
}

<!-- Classic Clean Filter Section -->
@if (filterPanelOpen) {
<div
  class="bg-white border border-gray-200 shadow-sm p-4 mb-4 ulb-filter-panel"
>
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end"
  >
    <!-- ULB Dropdown -->
    @if (tntLst.length>1) {
    <div class="flex flex-col">
      <label class="block text-sm font-medium text-gray-700 mb-1.5"
        >Select {{ hdrLbl }}</label
      >
      <nz-select
        class="w-full"
        nzShowSearch
        nzPlaceHolder="Select {{ hdrLbl }}"
        [(ngModel)]="selectedtenant"
        (ngModelChange)="ontntSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
        @for (t of tntLst; track t) {
        <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_dsply_nm"></nz-option>
        }
      </nz-select>
    </div>
    } @if (tntLst && tntLst.length==1) {
    <div class="flex flex-col">
      <label class="block text-sm font-medium text-gray-700 mb-1.5">{{
        hdrLbl
      }}</label>
      <div
        class="px-3 py-2 bg-gray-50 border border-gray-300 rounded text-gray-700 text-sm"
      >
        {{ tntLst[0].tnt_nm }}
      </div>
    </div>
    }
    <!-- Date Picker -->
    <div class="flex flex-col">
      <label class="block text-sm font-medium text-gray-700 mb-1.5"
        >Select Date</label
      >
      <nz-date-picker
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        (ngModelChange)="onChange($event)"
        class="w-full"
      >
      </nz-date-picker>
    </div>
  </div>
</div>
}

<!-- SECTION 1B: Urban Dashboard Style Cards -->
<div class="py-2 min-h-0 ulb-cards-section">
  <!-- Row 1: Vehicles Overview, Distance & Working Hours, VMU Maintained, Vehicle Live Status -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
    <!-- Card 1: Vehicles Overview -->
    <!-- trackBy: keeps the card DOM alive across refreshes so the
      cardSlideUp entrance animation does not replay (flash) each time. -->
    @for (d of tdyCoveredTrips; track $index; let first =
    $first) { @if (first) {
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-slate-600 to-slate-800 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
            ></path>
            <path
              d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white"
            >Vehicles Overview</span
          >
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/vehicle-dashboard')"
            title="Go to Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <!-- Stats Row -->
        <div class="grid grid-cols-4 gap-1 mb-2">
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ (d.urban_ttl || 0) + (d.rural_ttl || 0) }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Total</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ overallOwnerCounts.own || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Own</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ overallOwnerCounts.contract || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Contract</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-slate-700">
              {{ overallOwnerCounts.sac || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium uppercase">SAC</div>
          </div>
        </div>
        <!-- Primary & Secondary -->
        <div class="grid grid-cols-2 gap-2 flex-1">
          <!-- Primary -->
          <div
            class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex flex-col"
          >
            <div
              class="flex items-center justify-between mb-1.5 pb-1 border-b border-gray-200"
            >
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700"
                  >Primary</span
                >
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                d.primary_ttl || 0
              }}</span>
            </div>
            <div class="mb-1.5">
              <div class="flex justify-between mb-0.5">
                <span class="text-xs text-gray-500 font-medium"
                  >Operation %</span
                >
                <span class="text-xs font-semibold text-slate-600"
                  >{{ d.primary_opper || 0 }}%</span
                >
              </div>
              <div
                class="bg-gray-200 rounded-full overflow-hidden ulb-progress"
              >
                <div
                  class="h-full bg-blue-500 rounded-full"
                  [style.width.%]="d.primary_opper || 0"
                ></div>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-1 flex-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ d.primary_operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ d.primary_notoperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-3 gap-0.5 mt-1 pt-1 border-t border-gray-200"
            >
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ primaryOwnerCounts.own || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">OWN</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ primaryOwnerCounts.contract || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">CONTRACT</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ primaryOwnerCounts.sac || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">SAC</div>
              </div>
            </div>
          </div>
          <!-- Secondary -->
          <div
            class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex flex-col"
          >
            <div
              class="flex items-center justify-between mb-1.5 pb-1 border-b border-gray-200"
            >
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700"
                  >Secondary</span
                >
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                d.secondary_ttl || 0
              }}</span>
            </div>
            <div class="mb-1.5">
              <div class="flex justify-between mb-0.5">
                <span class="text-xs text-gray-500 font-medium"
                  >Operation %</span
                >
                <span class="text-xs font-semibold text-slate-600"
                  >{{ d.secondary_opper || 0 }}%</span
                >
              </div>
              <div
                class="bg-gray-200 rounded-full overflow-hidden ulb-progress"
              >
                <div
                  class="h-full bg-blue-500 rounded-full"
                  [style.width.%]="d.secondary_opper || 0"
                ></div>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-1 flex-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ d.secondary_operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 flex flex-col justify-center"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ d.secondary_notoperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
            <div
              class="grid grid-cols-3 gap-0.5 mt-1 pt-1 border-t border-gray-200"
            >
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ secondaryOwnerCounts.own || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">OWN</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ secondaryOwnerCounts.contract || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">CONTRACT</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-xs font-bold text-slate-700">
                  {{ secondaryOwnerCounts.sac || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">SAC</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } }
    <!-- Card 2: Distance & Working Hours -->
    @for (d of tdyCoveredTrips; track $index; let first =
    $first) { @if (first) {
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-emerald-600 to-teal-700 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white"
            >Distance & Working Hours</span
          >
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/vehicle-dashboard')"
            title="Go to Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-2">
          <!-- Distance -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div
              class="flex items-center justify-between mb-1.5 pb-1 border-b border-gray-200"
            >
              <div class="flex items-center gap-1.5">
                <svg
                  class="w-3.5 h-3.5 text-slate-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="text-sm font-semibold text-slate-700"
                  >Vehicles Travelled</span
                >
              </div>
              <span
                class="text-xs font-bold text-slate-700 bg-white px-2 py-0.5 rounded border border-gray-200"
                >{{ (d.op_dst_ct || 0) + (d.nop_dst_ct || 0) }}</span
              >
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-emerald-600">
                  {{ d.op_dst_ct || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">>= 500m</div>
                <div class="text-xs font-semibold text-emerald-500">
                  {{
                    ((d.op_dst_ct || 0) /
                      ((d.op_dst_ct || 0) + (d.nop_dst_ct || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-red-500">
                  {{ d.nop_dst_ct || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">&lt; 500m</div>
                <div class="text-xs font-semibold text-red-400">
                  {{
                    ((d.nop_dst_ct || 0) /
                      ((d.op_dst_ct || 0) + (d.nop_dst_ct || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
            </div>
          </div>
          <!-- Working Hours -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div
              class="flex items-center justify-between mb-1.5 pb-1 border-b border-gray-200"
            >
              <div class="flex items-center gap-1.5">
                <svg
                  class="w-3.5 h-3.5 text-slate-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="text-sm font-semibold text-slate-700"
                  >Working Hours</span
                >
              </div>
              <span
                class="text-xs font-bold text-slate-700 bg-white px-2 py-0.5 rounded border border-gray-200"
                >{{ (d.op_wrkd_ct || 0) + (d.nop_wrkd_ct || 0) }}</span
              >
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-emerald-600">
                  {{ d.op_wrkd_ct || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">>= 30 min</div>
                <div class="text-xs font-semibold text-emerald-500">
                  {{
                    ((d.op_wrkd_ct || 0) /
                      ((d.op_wrkd_ct || 0) + (d.nop_wrkd_ct || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-base md:text-lg font-bold text-red-500">
                  {{ d.nop_wrkd_ct || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">&lt; 30 min</div>
                <div class="text-xs font-semibold text-red-400">
                  {{
                    ((d.nop_wrkd_ct || 0) /
                      ((d.op_wrkd_ct || 0) + (d.nop_wrkd_ct || 0))) *
                      100 | number : "1.0-1"
                  }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div class="px-2 py-1 border-t border-gray-100">
          <p class="text-xs text-gray-400 mb-0 text-center font-medium">
            Distance-billed: Travelled >= 500m = Operated &nbsp;|&nbsp;
            Hours-billed: Working Hours >= 30 min = Operated
          </p>
        </div>
      </div>
    </div>
    } }
    <!-- Card 3: VMU Maintained -->
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-violet-500 to-purple-700 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
          <span class="text-base font-semibold text-white">VMU Maintained</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/vehicle-dashboard')"
            title="Go to Vehicle Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-2 flex-1">
          <!-- CDMA -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between mb-1.5">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">CDMA</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                vmuMaintainedData.cdma.total || 0
              }}</span>
            </div>
            <div class="flex justify-between items-center mb-0.5">
              <span class="text-xs text-gray-500 font-medium">Operation %</span>
              <span class="text-xs font-semibold text-slate-600"
                >{{ vmuMaintainedData.cdma.operatedPercent || 0 }}%</span
              >
            </div>
            <div
              class="bg-gray-200 rounded-full overflow-hidden ulb-progress mb-1.5"
            >
              <div
                class="h-full bg-blue-500 rounded-full"
                [style.width.%]="vmuMaintainedData.cdma.operatedPercent || 0"
              ></div>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ vmuMaintainedData.cdma.operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ vmuMaintainedData.cdma.notOperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
          </div>
          <!-- ULB -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between mb-1.5">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">ULB</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                vmuMaintainedData.ulb.total || 0
              }}</span>
            </div>
            <div class="flex justify-between items-center mb-0.5">
              <span class="text-xs text-gray-500 font-medium">Operation %</span>
              <span class="text-xs font-semibold text-slate-600"
                >{{ vmuMaintainedData.ulb.operatedPercent || 0 }}%</span
              >
            </div>
            <div
              class="bg-gray-200 rounded-full overflow-hidden ulb-progress mb-1.5"
            >
              <div
                class="h-full bg-blue-500 rounded-full"
                [style.width.%]="vmuMaintainedData.ulb.operatedPercent || 0"
              ></div>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ vmuMaintainedData.ulb.operated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Operated</div>
              </div>
              <div
                class="bg-white rounded-md p-3 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ vmuMaintainedData.ulb.notOperated || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Operated
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 4: Vehicle Live Status -->
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-blue-500 to-indigo-600 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
            />
          </svg>
          <span class="text-base font-semibold text-white"
            >Vehicle Live Status</span
          >
        </div>
        <div class="flex items-center gap-2">
          <div
            class="flex items-center gap-1 bg-emerald-500/30 px-2 py-0.5 rounded-full"
          >
            <span
              class="w-1.5 h-1.5 bg-emerald-300 rounded-full ulb-live-pulse"
            ></span>
            <span class="text-xs font-medium text-white uppercase tracking-wide"
              >Live</span
            >
          </div>
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('tracking/list')"
            title="Go to Vehicle Tracking"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <!-- Status Row -->
        <div class="grid grid-cols-3 gap-1 mb-1.5">
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-slate-700">
              {{ vehicleLiveStatus.total || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Total</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-emerald-600">
              {{ vehicleLiveStatus.online || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Online</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-red-500">
              {{
                vehicleLiveStatus.offline - vehicleLiveStatus.offline24hr || 0
              }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Offline</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-amber-600">
              {{ vehicleLiveStatus.repair || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Repair</div>
          </div>
          <div
            class="bg-gray-50 rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-sm md:text-base font-bold text-gray-600">
              {{ vehicleLiveStatus.others || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium">Others</div>
          </div>
        </div>
        <!-- Offline > 24 hrs Alert -->
        <div
          class="bg-red-50 rounded-lg p-1.5 border border-red-200 mb-1.5 flex items-center justify-between ulb-alert-badge"
          [ngClass]="{
            'ring-1 ring-red-300': vehicleLiveStatus.offline24hr > 0
          }"
        >
          <div class="flex items-center gap-1.5">
            <svg
              class="w-4 h-4 text-red-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-xs font-semibold text-red-600"
              >Offline > 24 Hrs</span
            >
          </div>
          <span
            class="text-base md:text-lg font-bold text-red-500 bg-white px-2 py-0.5 rounded-md border border-gray-200"
            >{{ vehicleLiveStatus.offline24hr || 0 }}</span
          >
        </div>
        <!-- Activity Grid -->
        <div class="grid grid-cols-3 gap-1">
          <div
            class="bg-white rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-emerald-600">
              {{ vehicleLiveStatus.running || 0 }}
            </div>
            <div class="flex items-center justify-center gap-0.5">
              <span class="w-1.5 h-1.5 bg-emerald-500 rounded-full"></span>
              <span class="text-xs font-medium text-gray-500 uppercase"
                >Running</span
              >
            </div>
          </div>
          <div
            class="bg-white rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-amber-600">
              {{ vehicleLiveStatus.parked || 0 }}
            </div>
            <div class="flex items-center justify-center gap-0.5">
              <span class="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
              <span class="text-xs font-medium text-gray-500 uppercase"
                >Parked</span
              >
            </div>
          </div>
          <div
            class="bg-white rounded-md p-1.5 text-center border border-gray-200"
          >
            <div class="text-base md:text-lg font-bold text-gray-600">
              {{ vehicleLiveStatus.onlineStandby24hr || 0 }}
            </div>
            <div class="flex items-center justify-center gap-0.5">
              <span class="w-1.5 h-1.5 bg-gray-400 rounded-full"></span>
              <span class="text-xs font-medium text-gray-500 uppercase"
                >24Hr Standby</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Row 2: Driver Type, Trips, Routes, Fuel Summary -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3 items-stretch"
  >
    <!-- Card 5: Driver Type -->
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-cyan-600 to-teal-700 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <span class="text-base font-semibold text-white">Driver Type</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >Total: {{ driverTypeCounts.total || 0 }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/driver-dashboard')"
            title="Go to Driver Dashboard"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-1.5 flex-1">
          <!-- OWN -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">OWN</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                driverTypeCounts.own || 0
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ driverTypeCounts.own_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Attended</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ driverTypeCounts.own_not_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Attended
                </div>
              </div>
            </div>
          </div>
          <!-- APCOS -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-slate-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700">APCOS</span>
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                driverTypeCounts.apcos || 0
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ driverTypeCounts.apcos_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Attended</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ driverTypeCounts.apcos_not_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Attended
                </div>
              </div>
            </div>
          </div>
          <!-- CONTRACT -->
          <div class="bg-gray-50 rounded-lg p-2 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <span class="w-1.5 h-4 bg-amber-500 rounded-full"></span>
                <span class="text-sm font-semibold text-slate-700"
                  >CONTRACT</span
                >
              </div>
              <span class="text-base md:text-lg font-bold text-slate-700">{{
                driverTypeCounts.contract || 0
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ driverTypeCounts.contract_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Attended</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ driverTypeCounts.contract_not_attended || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">
                  Not Attended
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 6: Trips -->
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-indigo-500 to-blue-700 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white">Trips</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/routeDeviation-dashboard')"
            title="Go to Route Deviation"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-2 gap-2 mb-2">
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-emerald-600">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.trps_asgnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Trips Defined
            </div>
          </div>
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-red-500">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.trps_not_asgnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Trips Not Defined
            </div>
          </div>
        </div>
        <div
          class="bg-gray-50 rounded-lg p-2 border border-gray-200 mb-1.5 flex-1"
        >
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Primary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_trps_asgnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-red-500">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_trps_not_asgnd_vhcls) ||
                    0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex-1">
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Secondary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.secondary_trps_asgnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-red-500">
                {{
                  (ttlTrpsCnt &&
                    ttlTrpsCnt[0]?.secondary_trps_not_asgnd_vhcls) ||
                    0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 7: Routes -->
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-teal-500 to-emerald-700 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="text-base font-semibold text-white">Routes</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('dashboard/routeDeviation-dashboard')"
            title="Go to Route Deviation"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-2 gap-2 mb-2">
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-emerald-600">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.rts_dfnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Routes Defined
            </div>
          </div>
          <div
            class="bg-gray-50 rounded-lg p-2 text-center border border-gray-200"
          >
            <div class="text-xl md:text-2xl font-bold text-amber-600">
              {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.rts_not_dfnd_vhcls) || 0 }}
            </div>
            <div class="text-xs text-gray-500 font-medium leading-tight">
              Vehicles with<br />Routes Not Defined
            </div>
          </div>
        </div>
        <div
          class="bg-gray-50 rounded-lg p-2 border border-gray-200 mb-1.5 flex-1"
        >
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-blue-500 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Primary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{ (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_rts_dfnd_vhcls) || 0 }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-amber-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.primary_rts_not_dfnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 rounded-lg p-2 border border-gray-200 flex-1">
          <div
            class="flex items-center gap-1.5 mb-1.5 pb-1 border-b border-gray-200"
          >
            <span class="w-1.5 h-4 bg-gray-400 rounded-full"></span>
            <span class="text-sm font-semibold text-slate-700"
              >Secondary Vehicles</span
            >
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-emerald-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.secondary_rts_dfnd_vhcls) || 0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Defined
              </div>
            </div>
            <div
              class="bg-white rounded-md p-1.5 text-center border border-gray-200"
            >
              <div class="text-base md:text-lg font-bold text-amber-600">
                {{
                  (ttlTrpsCnt && ttlTrpsCnt[0]?.secondary_rts_not_dfnd_vhcls) ||
                    0
                }}
              </div>
              <div class="text-xs text-gray-500 font-medium leading-tight">
                Vehicles<br />Not Defined
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Card 8: Fuel Summary -->
    <div class="bg-white overflow-hidden flex flex-col h-full ulb-card">
      <!-- Header -->
      <div
        class="bg-gradient-to-r from-amber-600 to-orange-700 px-3 py-2 flex items-center justify-between ulb-card-header"
      >
        <div class="flex items-center gap-2">
          <svg
            class="w-4 h-4 text-white/80"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5z"
            />
          </svg>
          <span class="text-base font-semibold text-white">Fuel Summary</span>
        </div>
        <div class="flex items-center gap-2">
          <span
            class="text-xs text-white font-medium bg-white/15 px-2.5 py-0.5 rounded-full"
            >{{ curTblDate }}</span
          >
          <span
            class="card-nav-arrow"
            (click)="navigateToPage('fuellog/list')"
            title="Go to Fuel Log"
          >
            <svg
              class="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-2 flex-1 flex flex-col">
        <div class="grid grid-cols-1 gap-1.5 flex-1">
          <!-- Current Month -->
          <div
            class="bg-gray-50 rounded-lg border border-gray-200 p-1.5 flex flex-col"
          >
            <div class="text-center mb-1">
              <span class="text-sm font-semibold text-slate-700 uppercase">{{
                currentMonthLabel || "Current"
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1 mb-1">
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ fuelCardData.totalUlbsFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Filled</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ fuelCardData.totalUlbsNotFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Not Filled</div>
              </div>
            </div>
            <div class="flex-1 grid grid-cols-3 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-amber-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(fuelCardData.diesel.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Diesel</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-blue-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(fuelCardData.petrol.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Petrol</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-emerald-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(fuelCardData.cng.kg) }} kg
                </div>
                <div class="text-xs font-medium text-gray-500">CNG</div>
              </div>
            </div>
          </div>
          <!-- Previous Month -->
          <div
            class="bg-gray-50 rounded-lg border border-gray-200 p-1.5 flex flex-col"
          >
            <div class="text-center mb-1">
              <span class="text-sm font-semibold text-slate-700 uppercase">{{
                previousMonthLabel || "Previous"
              }}</span>
            </div>
            <div class="grid grid-cols-2 gap-1 mb-1">
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-emerald-600">
                  {{ prevMonthFuelData.totalUlbsFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Filled</div>
              </div>
              <div
                class="bg-white rounded-md p-1 text-center border border-gray-200"
              >
                <div class="text-sm md:text-base font-bold text-red-500">
                  {{ prevMonthFuelData.totalUlbsNotFilled || 0 }}
                </div>
                <div class="text-xs text-gray-500 font-medium">Not Filled</div>
              </div>
            </div>
            <div class="flex-1 grid grid-cols-3 gap-1">
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-amber-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(prevMonthFuelData.diesel.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Diesel</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-blue-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(prevMonthFuelData.petrol.litres) }}
                </div>
                <div class="text-xs font-medium text-gray-500">Petrol</div>
              </div>
              <div
                class="bg-white rounded-md p-1.5 text-center border border-gray-200 relative"
              >
                <span
                  class="w-2 h-2 bg-emerald-500 rounded-full absolute top-1 right-1"
                ></span>
                <div class="text-sm md:text-base font-bold text-slate-700">
                  {{ formatNumber(prevMonthFuelData.cng.kg) }} kg
                </div>
                <div class="text-xs font-medium text-gray-500">CNG</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>

<!-- SECTION 2: Main Content Wrapper -->
<div class="px-5 md:px-6 py-5 ulb-main-content">
  <!-- SECTION 3: Graphs Section - 3 Charts in a Row -->
  <div class="mb-3 mt-2">
    <div
      class="grid grid-cols-1 lg:grid-cols-3 gap-4 ulb-charts-row items-stretch"
    >
      <!-- Chart 1: Operational Status -->
      <div class="bg-white overflow-hidden ulb-chart-card ulb-chart-uniform">
        <div
          class="ulb-chart-header bg-gradient-to-r from-slate-600 to-slate-800"
        >
          <div class="flex items-center gap-2">
            <i
              nz-icon
              nzType="bar-chart"
              nzTheme="outline"
              class="text-white/80"
            ></i>
            <h3 class="text-sm font-semibold text-white">
              Operational Status (Last 7 Days)
            </h3>
          </div>
          <span class="ulb-chart-badge">Total: {{ ttl_vhcls || 0 }}</span>
        </div>
        <div class="p-4 flex-1 flex flex-col">
          <div id="distanceTavelledChart" class="ulb-chart-body"></div>
        </div>
      </div>

      <!-- Chart 2: Travelled Trips % -->
      @if (clntDtls[0].clnt_id != 3000001) {
      <div class="bg-white overflow-hidden ulb-chart-card ulb-chart-uniform">
        <div
          class="ulb-chart-header bg-gradient-to-r from-indigo-500 to-blue-700"
        >
          <div class="flex items-center gap-2">
            <i
              nz-icon
              nzType="rise"
              nzTheme="outline"
              class="text-white/80"
            ></i>
            <h3 class="text-sm font-semibold text-white">
              Travelled Trips % (Last 7 Days)
            </h3>
          </div>
        </div>
        <div class="p-4 flex-1 flex flex-col">
          <div id="ctgrytripsTavelledChart" class="ulb-chart-body"></div>
          @if (nodata) {
          <div class="text-center text-slate-400 py-8 text-sm">
            {{ nodataMsg }}
          </div>
          }
        </div>
      </div>
      }

      <!-- Chart 3: Fuel Consumption -->
      @if (clntDtls[0].clnt_id != 3000001) {
      <div class="bg-white overflow-hidden ulb-chart-card ulb-chart-uniform">
        <div
          class="ulb-chart-header bg-gradient-to-r from-amber-600 to-orange-700"
        >
          <div class="flex items-center gap-2">
            <i
              nz-icon
              nzType="fire"
              nzTheme="outline"
              class="text-white/80"
            ></i>
            <h3 class="text-sm font-semibold text-white">
              Fuel Consumption (Last 7 Days)
            </h3>
          </div>
        </div>
        <div class="p-4 flex-1 flex flex-col">
          <div id="fuelLast7DaysChart" class="ulb-chart-body"></div>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- <li class="cards_item">
            <div class="card_g" style="background:linear-gradient(135deg, #b1ea4d 0%,#459522 100%);">
              <div class="card_content">
                <div class="row">
                  <h1 class="crdHdr">Primary Trips</h1>
                </div>
                <div class="row crdHdr_sb">
                  <div class="col-lg-6 col-md-6">
                    <h1>
                      <i nz-icon nzType="node-index" nzTheme="outline"></i>
                    </h1>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <h1 class="card_sub_title"  *ngIf="prmryTrpsCnt && prmryTrpsCnt.length && shwzrwErr == false">{{prmryTrpsCnt[0].prmy_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwzrwErr == true">0</h1>
                  </div>
                </div>
                <div class="row crdHdr_sb_sm">
                  <div class="col-lg-8 col-md-8">
                    <h1>
                      Running
                    </h1>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <h1 class="card_sub_title"  *ngIf="prmryTrpsCnt && prmryTrpsCnt.length && shwzrwErr == false">{{prmryTrpsCnt[0].prmy_runnig_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwzrwErr == true">0</h1>
                  </div>
                </div>
                <div class="row crdHdr_sb_sm">
                  <div class="col-lg-8 col-md-8">
                    <h1>
                      Yet to Start
                    </h1>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <h1 class="card_sub_title"  *ngIf="prmryTrpsCnt && prmryTrpsCnt.length && shwzrwErr == false">{{prmryTrpsCnt[0].prmy_yet_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwzrwErr == true">0</h1>
                  </div>
                </div>
                <div class="row crdHdr_sb_sm">
                  <div class="col-lg-8 col-md-8">
                    <h1>
                      Completed
                    </h1>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <h1 class="card_sub_title"  *ngIf="prmryTrpsCnt && prmryTrpsCnt.length && shwzrwErr == false">{{prmryTrpsCnt[0].prmy_cmpltd_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwzrwErr == true">0</h1>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="cards_item">
            <div class="card_g" style="background:linear-gradient(135deg, #f36265 0%,#b42b70 100%);">
              <div class="card_content">
                <div class="row">
                  <h1 class="crdHdr">Secondary Trips</h1>
                </div>
                <div class="row crdHdr_sb">
                  <div class="col-lg-6 col-md-6">
                    <h1>
                      <i nz-icon nzType="node-index" nzTheme="outline"></i>
                    </h1>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <h1 class="card_sub_title"  *ngIf="scndryTrpsCnt && scndryTrpsCnt.length && shwScndryzrwErr == false">{{scndryTrpsCnt[0].scndry_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwScndryzrwErr == true">0</h1>
                  </div>
                </div>
                <div class="row crdHdr_sb_sm">
                  <div class="col-lg-8 col-md-8">
                    <h1>
                      Running
                    </h1>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <h1 class="card_sub_title"  *ngIf="scndryTrpsCnt && scndryTrpsCnt.length && shwScndryzrwErr == false">{{scndryTrpsCnt[0].scndry_runnig_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwScndryzrwErr == true">0</h1>
                  </div>
                </div>
                <div class="row crdHdr_sb_sm">
                  <div class="col-lg-8 col-md-8">
                    <h1>
                      Yet to Start
                    </h1>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <h1 class="card_sub_title"  *ngIf="scndryTrpsCnt && scndryTrpsCnt.length && shwScndryzrwErr == false">{{scndryTrpsCnt[0].scndry_yet_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwScndryzrwErr == true">0</h1>
                  </div>
                </div>
                <div class="row crdHdr_sb_sm">
                  <div class="col-lg-8 col-md-8">
                    <h1>
                      Completed
                    </h1>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <h1 class="card_sub_title"  *ngIf="scndryTrpsCnt && scndryTrpsCnt.length && shwScndryzrwErr == false">{{scndryTrpsCnt[0].scndry_cmpltd_trps}}</h1>
                    <h1 class="card_sub_title"  *ngIf="shwScndryzrwErr == true">0</h1>
                  </div>
                </div>
              </div>
            </div>
          </li>  -->

  <!-- SECTION 4: Dynamic Content Based on Selected Card -->

  <!-- Vehicles Card Selected: Show Vehicles Table -->
  @if (selectedCard === 'vehicles') {
  <div class="mb-4 mt-2">
    <div class="bg-white overflow-hidden w-full ulb-table-card" #vehclesTable>
      <div class="flex items-center justify-between px-4 py-3 ulb-table-header">
        <div class="flex items-center gap-3">
          <h2 class="text-lg font-semibold text-gray-800 mb-0">
            ULB Wise {{ sbHdr }} Vehicles
          </h2>
          <span
            class="px-2 py-1 bg-blue-100 text-blue-700 text-sm font-medium rounded-full"
          >
            {{ vehclesTble.length }} records
          </span>
        </div>
        <div class="flex items-center gap-2">
          <button
            (click)="reset()"
            class="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 hover:shadow-md transition-all duration-200 group"
            title="Refresh Data"
          >
            <svg
              class="w-4 h-4 group-hover:rotate-180 transition-transform duration-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              ></path>
            </svg>
            <span class="ml-2">Refresh</span>
          </button>
        </div>
      </div>
      <!-- Vehicles Table - Full Width, horizontal scroll only -->
      <div class="w-full overflow-x-auto relative">
        <app-data-grid
          [toolbarItems]="pdfToolbar"
          [dataSource]="vehclesTble"
          [legacyColumns]="vehclesTblecolumnDefs"
          [searchPanel]="true"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="true"
          exportFileName="ulb wise operated Trips"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
          (cellClick)="onVehiclesCellClick($event)"
        >
          <!-- Vehicle Template with Own/Hired Badge -->
          <ng-template appGridCell="vehicleTemplate" let-data="cell"
            ><div title="Click to open vehicle details">
              <div class="flex items-center" style="gap: 6px">
                <span
                  class="cursor-pointer text-blue-600 hover:underline font-medium"
                  >{{ data.data.asrt_nm || "-" }}</span
                >
                @if (data.data.asrt_ownr_id == 1) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                  >Own</span
                >
                } @if (data.data.asrt_ownr_id == 2) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                  >Hired</span
                >
                }
              </div>
            </div></ng-template
          >
          <!-- Driver Template with Own/Hired Badge -->
          <ng-template appGridCell="driverTemplate" let-data="cell"
            ><div title="Click to open driver profile">
              <div class="flex items-center" style="gap: 6px">
                @if (data.data.crw_id) {
                <span
                  class="cursor-pointer text-blue-600 hover:underline font-medium"
                  >{{ data.data.crw_nm || "-" }}</span
                >
                } @if (!data.data.crw_id) {
                <span>{{ data.data.crw_nm || "-" }}</span>
                } @if (data.data.crw_own_in == 1) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                  >Own</span
                >
                } @if (data.data.crw_own_in == 2) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                  >Hired</span
                >
                }
              </div>
            </div></ng-template
          >
          <!-- Vehicle Status Template (Running/Parked/Offline) -->
          <ng-template appGridCell="vehicleStatusTemplate" let-data="cell"
            ><div>
              @if (data.data.asrt_sts_nm == 'Running') {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-700"
                >Running</span
              >
              } @if (data.data.asrt_sts_nm == 'Parked') {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-yellow-100 text-yellow-700"
                >Parked</span
              >
              } @if (data.data.asrt_sts_nm != 'Running' && data.data.asrt_sts_nm
              != 'Parked') {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-gray-100 text-gray-600"
                >{{ data.data.asrt_sts_nm || "-" }}</span
              >
              }
            </div></ng-template
          >
          <!-- Ignition Template (Yes/No) -->
          <ng-template appGridCell="ignitionTemplate" let-data="cell"
            ><div>
              @if (data.data.igntn_in == 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-700"
                >Yes</span
              >
              } @if (data.data.igntn_in != 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-red-100 text-red-600"
                >No</span
              >
              }
            </div></ng-template
          >
          <!-- Operational Status Template (Operated/Not Operated) -->
          <ng-template appGridCell="operationalStatusTemplate" let-data="cell"
            ><div>
              @if (data.data.opr_in == 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-700"
                >Operated</span
              >
              } @if (data.data.opr_in != 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-red-100 text-red-600"
                >Not Operated</span
              >
              }
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
  </div>
  }

  <!-- Operational Status Card Selected: Show Table -->
  @if (selectedCard === 'operational') {
  <div class="mb-4 mt-2">
    <div
      class="bg-white overflow-hidden w-full ulb-table-card"
      #operationalTable
    >
      <div class="flex items-center justify-between px-4 py-3 ulb-table-header">
        <div class="flex items-center gap-3 flex-wrap">
          <h2 class="text-lg font-semibold text-gray-800 mb-0">
            ULB Wise {{ sbHdr }} Vehicles
          </h2>
          <span
            class="px-2 py-1 bg-purple-100 text-purple-700 text-sm font-medium rounded-full"
          >
            {{ vehclesTble.length }} records
          </span>
          <span
            class="px-2 py-1 bg-green-100 text-green-700 text-sm font-medium rounded-full cursor-pointer"
            (click)="sortedVehData('oprtd')"
          >
            Operated: {{ operatedCount }}
          </span>
          <span
            class="px-2 py-1 bg-red-100 text-red-700 text-sm font-medium rounded-full cursor-pointer"
            (click)="sortedVehData('notoprtd')"
          >
            Not Operated: {{ notOperatedCount }}
          </span>
          <span
            class="px-2 py-1 bg-blue-100 text-blue-700 text-sm font-medium rounded-full"
          >
            Operated %: {{ operatedPercentage }}%
          </span>
        </div>
        <div class="flex items-center gap-2">
          @if (canExportPdf) {
          <button
            (click)="downloadVehiclesPdf()"
            class="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-red-700 bg-white border border-red-300 rounded-lg shadow-sm hover:bg-red-50 hover:border-red-400 hover:shadow-md transition-all duration-200 group"
            title="Download PDF"
          >
            <i nz-icon nzType="file-pdf" nzTheme="outline" class="mr-2"></i>
            <span>Export PDF</span>
          </button>
          }
          <button
            (click)="reset()"
            class="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 hover:shadow-md transition-all duration-200 group"
            title="Refresh Data"
          >
            <svg
              class="w-4 h-4 group-hover:rotate-180 transition-transform duration-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              ></path>
            </svg>
            <span class="ml-2">Refresh</span>
          </button>
        </div>
      </div>
      <!-- Vehicles Table - Full Width, horizontal scroll only -->
      <div class="w-full overflow-x-auto">
        <app-data-grid
          [dataSource]="vehclesTble"
          [legacyColumns]="vehclesTblecolumnDefs"
          [searchPanel]="true"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="true"
          exportFileName="ulb wise operated Trips"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
          (cellClick)="onVehiclesCellClick($event)"
        >
          <!-- Vehicle Template with Own/Hired Badge -->
          <ng-template appGridCell="vehicleTemplate" let-data="cell"
            ><div title="Click to open vehicle details">
              <div class="flex items-center" style="gap: 6px">
                <span
                  class="cursor-pointer text-blue-600 hover:underline font-medium"
                  >{{ data.data.asrt_nm || "-" }}</span
                >
                @if (data.data.asrt_ownr_id == 1) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                  >Own</span
                >
                } @if (data.data.asrt_ownr_id == 2) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                  >Hired</span
                >
                }
              </div>
            </div></ng-template
          >
          <!-- Driver Template with Own/Hired Badge -->
          <ng-template appGridCell="driverTemplate" let-data="cell"
            ><div title="Click to open driver profile">
              <div class="flex items-center" style="gap: 6px">
                @if (data.data.crw_id) {
                <span
                  class="cursor-pointer text-blue-600 hover:underline font-medium"
                  >{{ data.data.crw_nm || "-" }}</span
                >
                } @if (!data.data.crw_id) {
                <span>{{ data.data.crw_nm || "-" }}</span>
                } @if (data.data.crw_own_in == 1) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                  >Own</span
                >
                } @if (data.data.crw_own_in == 2) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                  >Hired</span
                >
                }
              </div>
            </div></ng-template
          >
          <!-- Vehicle Status Template (Running/Parked/Offline) -->
          <ng-template appGridCell="vehicleStatusTemplate" let-data="cell"
            ><div>
              @if (data.data.asrt_sts_nm == 'Running') {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-700"
                >Running</span
              >
              } @if (data.data.asrt_sts_nm == 'Parked') {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-yellow-100 text-yellow-700"
                >Parked</span
              >
              } @if (data.data.asrt_sts_nm != 'Running' && data.data.asrt_sts_nm
              != 'Parked') {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-gray-100 text-gray-600"
                >{{ data.data.asrt_sts_nm || "-" }}</span
              >
              }
            </div></ng-template
          >
          <!-- Ignition Template (Yes/No) -->
          <ng-template appGridCell="ignitionTemplate" let-data="cell"
            ><div>
              @if (data.data.igntn_in == 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-700"
                >Yes</span
              >
              } @if (data.data.igntn_in != 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-red-100 text-red-600"
                >No</span
              >
              }
            </div></ng-template
          >
          <!-- Operational Status Template (Operated/Not Operated) -->
          <ng-template appGridCell="operationalStatusTemplate" let-data="cell"
            ><div>
              @if (data.data.opr_in == 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-700"
                >Operated</span
              >
              } @if (data.data.opr_in != 1) {
              <span
                class="px-2 py-0.5 text-[10px] font-semibold rounded-full bg-red-100 text-red-600"
                >Not Operated</span
              >
              }
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
  </div>
  }

  <!-- Trips Card Selected: Show Trips Table -->
  @if (selectedCard === 'trips' && clntDtls[0].clnt_id != 3000001) {
  <div class="mb-4 mt-1">
    <div class="bg-white trips-table-wrapper w-full ulb-table-card" #tripsTable>
      <div class="flex items-center justify-between px-4 py-3 ulb-table-header">
        <div class="flex items-center gap-3">
          <h2 class="text-lg font-semibold text-gray-800 mb-0">
            ULB Wise {{ trpsbHdr }} Trips {{ curTblDate }}
          </h2>
          <span
            class="px-2 py-1 bg-emerald-100 text-emerald-700 text-sm font-medium rounded-full"
          >
            {{ tripsTrvldDta.length }} records
          </span>
        </div>
        <button
          (click)="reset()"
          class="inline-flex items-center justify-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 hover:shadow-md transition-all duration-200 group"
          title="Refresh Data"
        >
          <svg
            class="w-4 h-4 group-hover:rotate-180 transition-transform duration-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            ></path>
          </svg>
          <span class="ml-2">Refresh</span>
        </button>
      </div>
      @if (canExportPdf) {
      <button nz-button nzType="primary" (click)="downloadVehiclesPdf()">
        PDF
      </button>
      }
      <!-- Trips Table - Full Width, horizontal scroll only -->
      <div class="w-full overflow-x-auto">
        <app-data-grid
          [dataSource]="tripsTrvldDta"
          [legacyColumns]="tripsTrvldcolumnDefs"
          [searchPanel]="true"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="true"
          exportFileName="Trips Travelled Data"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
          [groupItems]="tripsGroupItems"
          (cellClick)="getVehDashSldr($event)"
        >
          <!-- Trips Vehicle Template with Own/Hired Badge -->
          <ng-template appGridCell="tripsVehicleTemplate" let-data="cell"
            ><div title="Click to view vehicle dashboard">
              <div class="flex items-center" style="gap: 6px">
                <span
                  class="cursor-pointer text-blue-600 hover:underline font-medium"
                  >{{ data.data.asrt_nm || "-" }}</span
                >
                @if (data.data.asrt_ownr_id == 1) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                  >Own</span
                >
                } @if (data.data.asrt_ownr_id == 2) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                  >Hired</span
                >
                }
              </div>
            </div></ng-template
          >
          <!-- Trips Driver Template with Own/Hired Badge -->
          <ng-template appGridCell="tripsDriverTemplate" let-data="cell"
            ><div title="Click to view driver dashboard">
              <div class="flex items-center" style="gap: 6px">
                @if (data.data.crw_id) {
                <span
                  class="cursor-pointer text-blue-600 hover:underline font-medium"
                  >{{ data.data.crw_nm || "-" }}</span
                >
                } @if (!data.data.crw_id) {
                <span>{{ data.data.crw_nm || "-" }}</span>
                } @if (data.data.crw_own_in == 1) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
                  >Own</span
                >
                } @if (data.data.crw_own_in == 2) {
                <span
                  class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
                  >Hired</span
                >
                }
              </div>
            </div></ng-template
          >
          <ng-template appGridCell="editTemplate" let-data="cell"
            ><div>
              @if (data) {
              <div class="tblEdtBtn" (click)="gotoPlaybck(data)">
                <i nz-icon nzType="node-index" nzTheme="outline"></i>
                <p>Playback</p>
              </div>
              }
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
  </div>
  }
</div>
